import React from 'react';
import { isNil } from 'lodash';
import { parseUrlParams } from '../../utils/parseUrlParams';

const Header = () => {
  const params = parseUrlParams(window.location.search);
  const hideHeader = !isNil(params.lusa_header) && params.lusa_header === 'false';

  return hideHeader ? null : (
    <div id="Header">
      <h1>React Router demo</h1>
    </div>
  );
};

export default Header;
